import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk'
import { apiMiddleware } from 'redux-api-middleware';
import createDebounce from 'redux-debounced';
import apiError from '../middleware/apiError';
import cableMiddleware from '../middleware/cableMiddleware';
import { communicationQueryMiddleware } from '../middleware/communicationQueryMiddleware';
import rootReducer from '../reducers';
import { loadingBarMiddleware } from 'react-redux-loading-bar';
import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension';
import { routerMiddleware } from 'connected-react-router'

const configureStore = history => createStore(
  rootReducer(history),
  composeWithDevToolsDevelopmentOnly(
    applyMiddleware(
      routerMiddleware(history),
      apiMiddleware,
      createDebounce(),
      thunk,
      cableMiddleware(),
      apiError,
      loadingBarMiddleware({
        promiseTypeSuffixes: ['REQUEST', '(RECEIVE|SUCCESS)', 'FAILURE'],
      }),
      communicationQueryMiddleware,
    )
  ),
)

export default configureStore
